<template>
    <section id="RPsbs-1445">
      <div class="cs-container">
        <!-- Left Image -->
        <picture class="cs-picture">
          <source media="(max-width: 600px)" :srcset="imageSrc">
          <source media="(min-width: 601px)" :srcset="imageSrc">
          <img loading="lazy" decoding="async" :src="imageSrc" alt="volunteers" width="650" height="600" aria-hidden="true">
        </picture>
  
        <!-- Content Section -->
        <div class="cs-content">
          <span class="cs-topper">Setting the Highest Standards</span>
          <h2 class="cs-title">Quality & Excellence</h2>
          <p class="cs-text">
            We strive to deliver the best possible care by maintaining high standards of professionalism, reliability, and continuous improvement. Our commitment to excellence ensures that every service we offer is safe, effective, and tailored to individual needs.
          </p>
  
          <!-- Dynamic List of Donation Methods -->
          <ul class="cs-card-group">
            <li v-for="(method, index) in donationMethods" :key="index" class="cs-li">
              <picture class="cs-li-picture">
                <img class="cs-li-icon" aria-hidden="true" :src="method.icon" decoding="async" alt="icon" width="32" height="32" loading="lazy">
              </picture>
              <div class="cs-flex">
                <h3 class="cs-h3">{{ method.title }}</h3>
                <p class="cs-li-text">
                  {{ method.description }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "Value3Section",
    data() {
      return {
        imageSrc: require("@/assets/images/values-3.jpg"),
        donationMethods: [
          {
            title: "A Team of Skilled and Dedicated Professionals",
            description: "Our caregivers and support staff are trained to deliver exceptional service, ensuring the highest level of care.",
            icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/volunteer1.svg"
          },
          {
            title: "Continuous Improvement Through Feedback and Innovation",
            description: "We actively seek feedback and implement best practices to enhance the quality of our services.",
            icon: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Icons/volunteer2.svg"
          }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  /*-- -------------------------- -->
<---       Side By Side         -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #RPsbs-1445,
  #RPsbsr-1445 {
    padding: var(--sectionPadding);
    overflow: hidden;
  }
  #RPsbs-1445 .cs-container,
  #RPsbsr-1445 .cs-container {
    width: 100%;
    /* changes to 1280px at desktop */
    max-width: 34.375rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* 48px - 64px */
    gap: clamp(3rem, 6vw, 4rem);
    position: relative;
  }
  #RPsbs-1445 .cs-content,
  #RPsbsr-1445 .cs-content {
    /* set text align to left if content needs to be left aligned */
    text-align: left;
    width: 100%;
    max-width: 33.875rem;
    display: flex;
    flex-direction: column;
    /* centers content horizontally, set to flex-start to left align */
    align-items: flex-start;
  }
  #RPsbs-1445 .cs-text,
  #RPsbsr-1445 .cs-text {
    margin-bottom: 1rem;
  }
  #RPsbs-1445 .cs-text:last-of-type,
  #RPsbsr-1445 .cs-text:last-of-type {
    margin-bottom: 2rem;
  }
  #RPsbs-1445 .cs-card-group,
  #RPsbsr-1445 .cs-card-group {
    width: 100%;
    max-width: 39.375rem;
    margin: 0 0 2rem 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 1.5rem;
  }
  #RPsbs-1445 .cs-li,
  #RPsbsr-1445 .cs-li {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    /* 16px - 20px */
    gap: clamp(1rem, 2.5vw, 1.25rem);
  }
  #RPsbs-1445 .cs-li-picture,
  #RPsbsr-1445 .cs-li-picture {
    width: 5rem;
    height: 5rem;
    margin: 0;
    border-radius: 50%;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    /* prevents flexbox from squishing it */
    flex: none;
    position: relative;
    z-index: 1;
  }
  #RPsbs-1445 .cs-li-picture:before,
  #RPsbsr-1445 .cs-li-picture:before {
    content: '';
    width: 100%;
    height: 100%;
    background: var(--primary);
    opacity: .1;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    z-index: -1;
  }
  #RPsbs-1445 .cs-li-icon,
  #RPsbsr-1445 .cs-li-icon {
    width: 2rem;
    height: auto;
    display: block;
  }
  #RPsbs-1445 .cs-h3,
  #RPsbsr-1445 .cs-h3 {
    font-size: 1.25rem;
    line-height: 1.2em;
    font-weight: 700;
    text-align: left;
    margin: 0 0 0.75rem 0;
    color: var(--headerColor);
  }
  #RPsbs-1445 .cs-li-text,
  #RPsbsr-1445 .cs-li-text {
    font-size: 1rem;
    line-height: 1.5em;
    text-align: left;
    margin: 0;
    color: var(--bodyTextColor);
  }
  #RPsbs-1445 .cs-button-solid,
  #RPsbsr-1445 .cs-button-solid {
    font-size: 1rem;
    /* 46px - 56px */
    line-height: clamp(2.875rem, 5.5vw, 3.5rem);
    text-decoration: none;
    font-weight: 700;
    text-align: center;
    margin: 0;
    color: #fff;
    min-width: 9.375rem;
    padding: 0 2rem;
    background-color: var(--primary);
    border-radius: 0.25rem;
    display: inline-block;
    position: relative;
    z-index: 1;
    /* prevents padding from adding to the width */
    box-sizing: border-box;
  }
  #RPsbs-1445 .cs-button-solid:before,
  #RPsbsr-1445 .cs-button-solid:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 0%;
    background: #000;
    opacity: 1;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: 0.25rem;
    transition: width .3s;
  }
  #RPsbs-1445 .cs-button-solid:hover:before,
  #RPsbsr-1445 .cs-button-solid:hover:before {
    width: 100%;
  }
  #RPsbs-1445 .cs-picture,
  #RPsbsr-1445 .cs-picture {
    width: 100%;
    max-width: 40.625rem;
    min-height: 22.625rem;
    border-radius: 1.5rem;
    /* clips img tag corners */
    overflow: hidden;
    display: block;
    position: relative;
    z-index: 1;
  }
  #RPsbs-1445 .cs-picture img,
  #RPsbsr-1445 .cs-picture img {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}
/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
  #RPsbs-1445 .cs-container,
  #RPsbsr-1445 .cs-container {
    max-width: 80rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    position: relative;
  }
  #RPsbs-1445 .cs-content,
  #RPsbsr-1445 .cs-content {
    width: 50%;
    padding: 2.5rem 0;
  }
  #RPsbs-1445 .cs-picture,
  #RPsbsr-1445 .cs-picture {
    height: auto;
    width: 55%;
  }
}

/*-- -------------------------- -->
<---   Side By Side Reverse     -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #RPsbsr-1445 {
    background-color: #f7f7f7;
  }
}
/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
  #RPsbsr-1445 .cs-picture {
    /* sends it to the right in the 2nd position */
    order: 2;
  }
}
  </style>
  